import { render } from "./viewcharade.vue?vue&type=template&id=46c0dbe7"
import script from "./viewcharade.vue?vue&type=script&lang=js"
export * from "./viewcharade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__